<!-- 首页 -->
<template>
  <div class="cet-index">
    <HeaderTop
      :bgShow="bgShow"
      :subNavList="subNavList"
      @showYearBox="showYearBox"
    />
    <!-- 轮播 -->
    <Banner :bannerList="bannerList" @click.native="goback()" />
    <div class="course-list">
      <div v-for="(item, keys) in courseInfoData" :key="keys" @click="goback()">
        <CombinationCard v-if="item.setType === 1" :key="keys" :item="item" />
        <HotCourseCard v-else :key="keys" :item="item" />
      </div>
    </div>
    <!-- 选择考季 -->
    <SelectType v-if="isYearTabBox" :newData="newData" @closeYearBox="closeYearBox" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import iconList from '@/utils/iconsTypes';
import HeaderTop from '@/pages/arkHome/components/appHeaderTop.vue';
import SelectType from '@/pages/arkHome/components/selectTypes.vue';
import {
  reqTypeList, reqMajorAd, reqAdvertPlaying, reqProducts,
} from '@/api/home';
import { reqCombinationlist } from '@/api/combination';
import HotCourseCard from '@/components/hotCourseCard/hotCourseCard.vue';
import Banner from '@/pages/arkHome/components/bannerVant.vue';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
import {deepCopy} from "@/utils/tools";

export default {
  data() {
    return {
      bannerList: [],
      isYearTabBox: false,
      navList: [], // 导航栏
      newData: [], // 合并图片后的数据
      subNavList: [], // 二级类目列表
      courseInfoData: [],
      finished: false,
      loading: false,
      page: 1,
      ids: [],
      bgShow: true,
    };
  },

  components: {
    HeaderTop,
    SelectType,
    HotCourseCard,
    Banner,
    CombinationCard,
  },

  computed: {
    ...mapState(['currentYear', 'userInfo']),
  },
  created() {},
  mounted() {
    this.getTypeList();
    this.getBanner();
  },
  destroyed() {},
  methods: {
    ...mapActions(['setcurrentyear']),
    // 轮播图
    async getBanner() {
      const adcode = 'App220001';
      const res = await reqAdvertPlaying([adcode]);
      this.bannerList = res.data?.find(
        (item) => item.adCode === adcode,
      )?.advertisingContentWebInfoRespVOS;
    },
    goback() {
      sessionStorage.setItem('back', true);
    },

    async getTypeList() {
      const res = await reqTypeList('HOME_EXAM_CONFIG_H5');
      if (res.code === 0) {
        this.navList = res.data;
        const remark = this.navList.find((item) => item.code === '1')?.remark;
        this.getCourseAd(JSON.parse(remark || '{}').recommendId);
        // res.data.forEach((item) => {
        //   if (Number(item.code) === Number(this.currentYear.examTypeId)) {
        //     this.setcurrentyear(item);
        //   }
        // });
        this.navList.map((item) => {
          // eslint-disable-next-line array-callback-return
          iconList.map((e) => {
            if (item.code === e.code) {
              Object.assign(item, e);
            }
          });
          return item;
        });
        this.newData = this.navList;
      }
    },

    // 显示选择年份弹框
    showYearBox() {
      this.isYearTabBox = true;
      if (this.$root.$data.isApp) {
        this.$sendToApp('hideBottomSidebar');
      }
    },
    // 关闭选择年份弹框
    closeYearBox() {
      this.isYearTabBox = false;
      // App显示底部导航
      if (this.$root.$data.isApp) {
        this.$sendToApp('showBottomSidebar');
      }
    },
    // 查询广告位
    async getCourseAd(recommendId) {
      const { code, data } = await reqMajorAd(recommendId);
      if (code === 0 && data?.length) {
        const { recommendContentVOList } = data[0];
        this.getMajorList(recommendContentVOList);
      }
      this.resetProductData([]);
    },
    // 查询课程卡片信息
    async getMajorList(recommendContentVOList) {
      const allProductIds = [];
      const allPackageIds = [];
      (recommendContentVOList || []).forEach((child) => {
        if (child.recommendType === 0) {
          allProductIds.push(child.productId);
        } else {
          allPackageIds.push(child.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProducts(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};

      Promise.all([p1, p2]).then((result) => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = this.resetProductData(res?.data || [], 2);
        const resPackage = this.resetCoursePackage(res1?.data || []);
        const allCourse = [];
        recommendContentVOList.forEach((child) => {
          const findRes = [...resCourse, ...resPackage].find((course) => {
            const id = child.recommendType === 0 ? course.productId : course.packageId;
            return id === child.productId;
          });
          // eslint-disable-next-line no-unused-expressions
          findRes && allCourse.push(findRes);
        });
        this.courseInfoData = allCourse;
      });
    },
    // 自定义数据格式
    resetProductData(courseList) {
      courseList.forEach((item) => {
        const copyItem = deepCopy(item)
        const { productDiscountRespVO, teacherRespVOS } = item;
        Object.assign(item, {
          isArk: 1,
          salesVolume: Number(item.realSales) + Number(item.initialSales),
          courseBeginTime: item.startTime, // 开课时间
          isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
          isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
          teacherRespVOS: teacherRespVOS?.map((teacher) => ({
            teacherHead: teacher.teacherHead ? teacher.teacherHead : '',
            name: teacher.name,
          })),
        });
        if (
          productDiscountRespVO?.isCouponDiscount
          && productDiscountRespVO?.couponDiscount
          && item.sellPrice > 0
          && !productDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: productDiscountRespVO.discountPrice,
          });
        }
        if (productDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: productDiscountRespVO?.promotionLabel,
            originalPrice: (
              Number(productDiscountRespVO.discountMinPrice)
              + Number(productDiscountRespVO.discountAmount)
            ).toFixed(2),
            sellPrice: productDiscountRespVO.discountMinPrice,
            acvitityShowTime: productDiscountRespVO?.promotionShowTime,
            acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: productDiscountRespVO?.promotionEndTime,
          });
        }
        if (productDiscountRespVO?.isGroupDiscount) {
          Object.assign(item, {
            promotionLabel: 5,
            originalPrice: copyItem.sellPrice,
            sellPrice: productDiscountRespVO.discountMinPrice,
          });
        }
      });
      return courseList;
    },
    // 套餐卡片
    resetCoursePackage(majorCourseList) {
      majorCourseList.forEach((item) => {
        const { packageDiscountRespVO } = item;
        Object.assign(item, {
          isArk: 1,
          setType: 1,
          salesVolume: Number(item.actualSales) + Number(item.initialSales),
          isCouponDiscount: packageDiscountRespVO?.isCouponDiscount, // 优惠券
        });
        if (
          packageDiscountRespVO?.isCouponDiscount
          && item.sellPrice > 0
          && !packageDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
          });
        }
        if (packageDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: packageDiscountRespVO?.promotionLabel,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
            acvitityShowTime: packageDiscountRespVO?.promotionShowTime,
            acvitityStartTime: packageDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: packageDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return majorCourseList;
    },
  },
};
</script>

<style lang="scss" scoped>
.cet-index {
  width: 100%;
  min-height: 100%;
  padding: 120px 0 20px 0;
  //   background: #fefeff;
}
.course-list {
  position: relative;
  padding: 0 40px;
}
::v-deep .topType {
  display: none;
}
</style>
